import React, { memo } from 'react';
import cc from 'classcat';
import PropTypes from 'prop-types';
import { isValid } from 'date-fns';
import parseUTC from 'lib/parseUTC';
import { TIME } from 'lib/formatters';
import LoadingElement from 'components/Loading/LoadingElement';
import './flipClock.css';

const WARNING = 20000;
const SECONDS_IN_MINUTE = 60;
const MINUTES_IN_HOUR = 60;
const HOURS_IN_DAY = 24;

const FlipClock = ({ timeLeft }) => {
  const utcTimeLeft = parseUTC(new Date(timeLeft));
  const s = Math.floor(timeLeft / TIME.SECOND);
  const m = Math.floor(s / SECONDS_IN_MINUTE);
  const h = Math.floor(m / MINUTES_IN_HOUR);
  const d = Math.floor(h / HOURS_IN_DAY);

  const result = {
    days: d.toString(),
    hours: (h % HOURS_IN_DAY).toString(),
    minutes: (m % MINUTES_IN_HOUR).toString(),
    seconds: (s % SECONDS_IN_MINUTE).toString()
  };

  Object.keys(result).forEach((key) => {
    if (result[key].length === 1) {
      result[key] = `0${result[key]}`;
    }
  });

  const timerClass = cc([
    'flipClock',
    {
      'flipClock--ending': timeLeft <= WARNING
    }
  ]);

  return isValid(utcTimeLeft) && timeLeft >= TIME.SECOND ? (
    <div className={timerClass}>
      {timeLeft >= TIME.DAY ? (
        <div className="flipClock__group flipClock__group--d">
          <span className="flipClock__digits">{result.days}:</span>
        </div>
      ) : null}
      {timeLeft >= TIME.HOUR ? (
        <div className="flipClock__group flipClock__group--h">
          <span className="flipClock__digits">{result.hours}:</span>
        </div>
      ) : null}
      <div className="flipClock__group flipClock__group--m">
        <span className="flipClock__digits">{result.minutes}:</span>
      </div>
      <div className="flipClock__group flipClock__group--s">
        <span className="flipClock__digits">{result.seconds}</span>
      </div>
    </div>
  ) : (
    <LoadingElement />
  );
};

FlipClock.propTypes = {
  timeLeft: PropTypes.number
};
FlipClock.defaultProps = {
  timeLeft: undefined
};

export default memo(FlipClock);
